import Router, { Route } from 'vue-router';
import { config } from '@/config';

export function localizedRoute(routeObject: any, localeCode: string): any {
  if (routeObject && localeCode) {
    if (typeof routeObject === 'object') {
      if (routeObject.name) {
        routeObject.name = localeCode + '-' + routeObject.name;
      }
      if (routeObject.path) {
        routeObject.path = '/' + localeCode + '/' + routeObject.path.slice(1);
      }
    } else {
      return '/' + localeCode + routeObject;
    }
  }
  return routeObject;
}

export function localizeRoutes(router: Router, routes: []): void {
  if (config.i18n.availableLocale.length > 0) {
    for (const locale of config.i18n.availableLocale) {
      const code = (locale as any).code;
      if (code) {
        const localizedRoutes = [];
        for (const route of routes) {
          const localRoute = localizedRoute(Object.assign({}, route), code);
          localizedRoutes.push(localRoute);
        }
        router.addRoutes(localizedRoutes);
      }
    }
  }
}

export function localeCodeFromRoute(matchedRoute: Route): string {
  if (matchedRoute) {
    for (const locale of config.i18n.availableLocale) {
      const code = (locale as any).code;
      if (matchedRoute.path.indexOf(`/${code}/`) === 0 || matchedRoute.path === `/${code}`) {
        return code;
      }
    }
  }
  return '';
}
